import { useEffect, useState } from 'react';
import logoCharte from '../assets/top-formation.png';
import { useMarque } from './useMarque';

/**
 * Le logo de la marque en vigueur (TF-436), à défaut celui de la charte. Un
 * logo déposé qui ne se charge plus laisse place à celui de la charte plutôt
 * qu'à une image cassée.
 */
export function LogoMarque({ className }: { className: string }): JSX.Element {
  const { marque } = useMarque();
  const source = marque.logo?.url ?? logoCharte;
  const [enErreur, setEnErreur] = useState(false);
  useEffect(() => setEnErreur(false), [source]);
  return (
    <img
      src={enErreur ? logoCharte : source}
      alt={marque.nom}
      className={`${className} max-w-full object-contain`}
      onError={() => setEnErreur(true)}
    />
  );
}
